import { TAnalyticsUser } from '../../types/analytics';
import { TApplicationState } from '../../types/redux';

export function getAnalyticsUser(state: TApplicationState): TAnalyticsUser {
  if (!state.user) {
    return {};
  }

  const { cianUserId, realtyUserId, lastName, firstName, phone, phoneConfirmed, email, displayName } = state.user;
  const type = state.userRole ?? undefined;

  return {
    userId: realtyUserId,
    type: type,
    extra: {
      email,
      firstName,
      phone,
      phoneConfirmed,
      lastName,
      cianUserId,
      displayName,
    },
  };
}
